function coordinatesOf(latLng) {
  return {
    latitude: latLng.lat(),
    longitude: latLng.lng(),
  };
}

function samePoint(left, right) {
  return left.latitude === right.latitude && left.longitude === right.longitude;
}

export function polygonPathToWkt(path) {
  const points = path.getArray().map(coordinatesOf);
  if (points.length === 0) return '';

  const first = points[0];
  const last = points[points.length - 1];
  const ring = samePoint(first, last) ? points : [...points, first];
  const coordinates = ring.map((point) => `${point.longitude} ${point.latitude}`).join(', ');

  return `POLYGON((${coordinates}))`;
}
